import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap'
import { Button, Image } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'

import { firebase } from '../../../config/firebase'

class Login extends Component {

  constructor(props) {
    super(props)
    this.state = {
      usrName: "",
      email: "",
      password: "",
      isLoading: false,
    }
  }

  async componentDidMount() {
    const curUser = await firebase.auth().currentUser
    if (curUser === null) {
      this.props.history.replace('/login')
    }
  }

  OnChangeEmail = (e) => {
    this.setState({ email: e.target.value })
  }

  OnChangePassword = (e) => {
    this.setState({ password: e.target.value })
  }

  Forgot_onclk = async () => {
    // alert('Forgot')
    var email = this.state.email;
    if (email!==''){
      firebase.auth().sendPasswordResetEmail(email).then(function () {
        alert('Password Reset Email Sent!');
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === 'auth/invalid-email') {
          alert(errorMessage);
        } else if (errorCode === 'auth/user-not-found') {
          alert(errorMessage);
        }
        console.log(error);
      });
    }else{
      alert('Please enter an email address and click Forgot password.')
    }
  }

  Verify_onclk = async () => {
    var email = this.state.email;
    var password = this.state.password;
    if (email!=='' && password!==''){

      // manual change displayname
      // const auth = await firebase.auth().signInWithEmailAndPassword(email, password)
      // const user = firebase.auth().currentUser;
      // console.log(user)
      // await user.updateProfile({
      //   displayName: "Raofm",
      //   // photoURL: "https://example.com/jane-q-user/profile.jpg"
      // }).then(() => {
      //   // Update successful
      //   // ...
      // }).catch((error) => {
      //   // An error occurred
      //   // ...
      // }); 
      // console.log(user)
      // firebase.auth().signOut()

      try {
        const auth = await firebase.auth().signInWithEmailAndPassword(email, password)
        const user = firebase.auth().currentUser;

        if (user.emailVerified === true) {
          const userRef = await firebase.database().ref().child("User").child(user.displayName)
          const ref = await userRef.once('value')
          await localStorage.setItem('DISPLAYNAME', user.displayName)
          await localStorage.setItem('email', user.email)
          await userRef.child('Visits').transaction((current) => (current || 0) + 1)
          this.props.history.push('/dashboard')
          console.log('verified')
        } else if (user.emailVerified === false) {
          console.log('not verified')
          firebase.auth().currentUser.sendEmailVerification()
          .then(() => {
            alert('Email verification sent!')
          }).then(() => {
            firebase.auth().signOut()
          }).then(() => {
            this.props.history.replace('/login')
          }).catch((error) => {
            console.log(error)
            // ...
          }); 
          
        }

      } catch (error) {
        var errorCode = error.code
        var errorMessage = error.message
        if (errorCode === 'auth/wrong-password') {
          alert('Wrong password.')
        } else {
          alert('error')
          console.log(errorMessage)
        }
      }
    }else{
      firebase.auth().signOut()
      alert('Please enter an email address and password then click Resend Verifiaction Email')
      this.props.history.replace('/login')
    }
  }


  LogInClick = async () => {
    this.setState({ isLoading: true })

    // login after signed up
    var email = this.state.email
    var password = this.state.password
    if (email.length < 4) {
      alert('Please enter an email address.')
      this.props.history.replace('/login')
      this.setState({ isLoading: false })
      return
    }
    if (password.length < 4) {
      alert('Please enter a password.')
      this.props.history.replace('/login')
      this.setState({ isLoading: false })
      return
    }

    try {
      const auth = await firebase.auth().signInWithEmailAndPassword(email, password)
      if (auth) {
        await firebase.auth().onAuthStateChanged(async firebaseUser => {
          if (!!firebaseUser) {
            console.log(firebaseUser)
            if (firebaseUser.emailVerified) {
              const pre_ref = await firebase.database().ref("User").child(firebaseUser.displayName)
              // Check trained 
              await pre_ref.child("train_pass").once("value")
              .then(async function (snapshot) {
                if (snapshot.exists() === false) {
                  // alert('Not exist')
                  await pre_ref.update({
                    'train_pass':'no',
                    'train_score': 0,
                    'train_time': 0
                  })
                } else{
                  // console.log("Exits")
                }
              })
              
              await localStorage.setItem('DISPLAYNAME', firebaseUser.displayName)
              await localStorage.setItem('email', firebaseUser.email)
              const articleRef = await firebase.database().ref().child("User").child(firebaseUser.displayName)
              const ref = await articleRef.once('value')
              await localStorage.setItem('OCCSTATUS', await ref.child("Occupation").val())
              await localStorage.setItem('ADMINSTATUS', await ref.child("AdminOption").val())
              await localStorage.setItem('HOSPITAL', await ref.child("Hospital").val())
              await localStorage.setItem('train_pass', await ref.child("train_pass").val())
              await localStorage.setItem('train_score', await ref.child("train_score").val())
              await localStorage.setItem('train_time', await ref.child("train_time").val())
              
              var Hoscheck = true
              const Hosref = await firebase.database().ref("Hospital_information")
              let HosName = await ref.child("Hospital").val()
              // Check HosTotal
                await Hosref.child(HosName).once("value")
                .then(async function (snapshot) {
                  if (snapshot.exists() === false) {
                    console.log("Your Hospital does not exits. Please contact admin.")
                    Hoscheck = false
                  } 
                })


              if (ref && Hoscheck === true) {
                await articleRef.child('Visits').transaction((current) => (current || 0) + 1)
                this.props.history.push('/dashboard')
              }else {
                this.props.history.push('/page500')
              }
            } else {
              alert('Please verify your email then login again.')
              await firebase.auth().signOut()
              this.props.history.replace('/login')
            }
          }
        })
      }
    } catch (error) {
      var errorCode = error.code
      var errorMessage = error.message
      if (errorCode === 'auth/wrong-password') {
        alert('Wrong password.')
      } else {
        console.log(errorMessage)
      }
    }

    
    setTimeout(() => {
      this.setState({ isLoading: false })
    }, 1000)

  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input onChange={this.OnChangeEmail} type="text" placeholder="Please Eneter yout Email" autoComplete="Email" />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input onChange={this.OnChangePassword} type="password" placeholder="Password" autoComplete="current-password" />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button loading={this.state.isLoading} color="blue" className="px-4" onClick={this.LogInClick}>Login</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Button onClick={() => this.props.history.push('/register')} className="px-2">Register Now!</Button>
                        </Col>
                      </Row>
                      <Row>
                      <Col className='mt-2 d-flex justify-content-start' xs="6">
                          <Link onClick={this.Verify_onclk} to='/forgot-password'>Resend Verification Email</Link>
                        </Col>
                        <Col className='mt-2 d-flex justify-content-end' xs="6">
                          <Link onClick={this.Forgot_onclk} to='/forgot-password'>Forgot password</Link>
                        </Col>
                      </Row>
                      <Row>
                        <Col className='mt-2 d-flex justify-content-end' xs="12">
                          <a style={{ color: '#1976d2' }} onClick={() => this.props.history.push('/policy')}>Privacy Policy</a>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
                <Card className="text-white py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                  <CardBody className="text-center d-flex align-items-center justify-content-center">
                    <Image src={require('../../../assets/img/web_logo02.png')} size='small' className='img-fluid' />
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js